'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactGateway = require('react-gateway');

var _reactModal = require('react-modal2');

var _reactModal2 = _interopRequireDefault(_reactModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Modal = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(Modal, _React$Component);

  function Modal() {
    (0, _classCallCheck3.default)(this, Modal);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(Modal).apply(this, arguments));
  }

  (0, _createClass3.default)(Modal, [{
    key: 'render',
    value: function render() {
      var styles = require('./Modal.scss');
      return _react2.default.createElement(
        _reactGateway.Gateway,
        { into: 'modal' },
        _react2.default.createElement(
          _reactModal2.default,
          {
            onClose: this.props.onClose,
            closeOnEsc: this.props.closeOnEsc,
            closeOnBackdropClick: this.props.closeOnEsc,
            backdropClassName: styles.backdrop,
            modalClassName: styles.modal },
          this.props.children
        )
      );
    }
  }]);
  return Modal;
}(_react2.default.Component), _class.propTypes = {
  onClose: _react2.default.PropTypes.func.isRequired,
  closeOnEsc: _react2.default.PropTypes.bool,
  closeOnBackdropClick: _react2.default.PropTypes.bool
}, _temp);


Modal.getDefaultProps = {
  closeOnEsc: true,
  closeOnBackdropClick: true
};

exports.default = Modal;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Modal/Modal.js
 ** module id = 1101
 ** module chunks = 0
 **/